<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px">
        <div class="edit">
          <span style="width: 100%;display: flex;justify-content: left;padding: 10px 0px;">
             <span style="width: 63px; background-color: #589ff9;cursor: pointer;border-radius: 5px;margin-left: 15px;"    @click="activeEvt(1)"   >
                    <img src="../../../../images/increase.png"   style="width: 15px; height: 15px" alt=""/>
                  </span>
          </span>
          <el-table :data="tableData" border style="width:541px;margin-left: 15px;" @cell-click="idEvt">
            <el-table-column fixed prop="id" label="ID" width="200">
            </el-table-column>
            <el-table-column fixed prop="value_1" label="一级类别" width="120">
            </el-table-column>
            <el-table-column prop="is_active" label="是否显示" width="120">
              <template slot-scope="props">
                <span v-if="props.row.is_active === 1">有效</span>
                <span v-else-if="props.row.is_active === 2">无效</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="100">
              <template slot-scope="props">
                <el-button type="text" size="small" @click="activeEvt(2)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-main>
    <el-dialog :visible.sync="dialogFormVisible" width="500px" :before-close="handleClose">
      <el-form>
        <el-form-item label="一级类别" :label-width="formLabelWidth">
          <el-input v-model="name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否有效" :label-width="formLabelWidth">
          <el-radio-group v-model="radio">
            <el-radio :label="1">有效</el-radio>
            <el-radio :label="2">无效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleBet">取 消</el-button>
        <el-button type="primary" @click="handle">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import { ERPIndexApi, ERPEditApi } from "@/api/basic_data/index.js"
// ERPSaveApi
export default {
  components: {

    GlobalHeader
  },
  data() {

    return {
      activeIndex: "9-2-1",
      dialogVisible: false,
      radio: 1,
      name: '',
      type: 'khlx',
      selectedId: null,
      tableData: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
    };
  },
  created() {
    ERPIndexApi({
      type: this.type,
    }).then((res) => {
      this.tableData = res.data
    })
  },
  mounted() {
  },
  methods: {
    handle() {
       if (!this.name) {
         this.$message.error('请填写内容');
        return;
      }
      const params = {
        value_1: this.name,
        is_active: this.radio,
        type: this.type,
      };
      if (this.selectedId) {
        params.id = this.selectedId;
      }
      ERPEditApi(params).then((res) => {
        if (res.code == 1000) {
          this.name = '';
          this.radio = 1;
          this.dialogFormVisible = false;
          this.getList()
          this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            });
          } else {
            this.$message.error(res.msg)
        }
      });
    },
    handleClose() {
      this.name = '';
      this.radio = 1;
      this.selectedId = '';
      this.dialogFormVisible = false
    },
    handleBet() {
      this.name = '';
      this.radio = 1;
      this.selectedId = '';
      this.exchange_rate = '';
      this.identification = '';
      this.dialogFormVisible = false
    },
    idEvt(row, column, cell, event) {
      this.selectedId = row.id,
        this.name = row.value_1
      this.radio = row.is_active

    },
    activeEvt(value) {
      if (value == 1) {
        this.selectedId = '';
      } else if (value == 2) {
        const selectedId = this.selectedId;
        this.name = this.name
        this.radio = this.is_active
      }
      this.dialogFormVisible = true
    },
    getList() {
      ERPIndexApi({
        type: this.type,
      }).then((res) => {
        this.tableData = res.data
      })
    },
  },
};
</script>


<style lang="less" scoped>
.el-main {
  left: 175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

.edit {}

/deep/.el-table .el-table__cell {
  padding: 8.5px 0;
}
</style>



// WEBPACK FOOTER //
// src/src/basic_data/Project_related/Affiliated_company/index.vue